import React, { useCallback, useEffect, useState } from "react";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Checkbox } from "../components/ui/checkbox";
import ConfirmDialog from "../components/ConfirmDialog";
import { ListChecks, Plus, Trash2, Clock, Bell, CheckCircle2, AlarmClock } from "lucide-react";
import { toast } from "sonner";
import { trUpper } from "../lib/mw";

const LEAD = [
  { v: 0, l: "TAM ZAMANINDA" }, { v: 15, l: "15 DK ÖNCE" }, { v: 60, l: "1 SAAT ÖNCE" },
  { v: 1440, l: "1 GÜN ÖNCE" },
];

export default function Tasks() {
  const [tasks, setTasks] = useState([]);
  const [form, setForm] = useState({ title: "", note: "", due_at: "", remind: true, remind_before: 60, phone: "" });
  const [confirm, setConfirm] = useState(null);

  const load = useCallback(() => { api.get("/tasks").then((r) => setTasks(r.data)); }, []);
  useEffect(() => { load(); }, [load]);

  const toIso = (local) => (local ? new Date(local).toISOString() : "");
  const toLocal = (iso) => {
    if (!iso) return "";
    const d = new Date(iso); const off = d.getTimezoneOffset();
    return new Date(d.getTime() - off * 60000).toISOString().slice(0, 16);
  };

  const add = async () => {
    if (!form.title.trim()) { toast.error("BAŞLIK GEREKLİ"); return; }
    await api.post("/tasks", { ...form, title: trUpper(form.title), note: trUpper(form.note), due_at: toIso(form.due_at), remind_before: Number(form.remind_before), phone: form.phone });
    toast.success("İŞ EKLENDİ");
    setForm({ title: "", note: "", due_at: "", remind: true, remind_before: 60, phone: "" });
    load();
  };
  const toggleDone = async (t) => { await api.put(`/tasks/${t.id}`, { ...t, done: !t.done }); load(); };
  const del = async () => { await api.delete(`/tasks/${confirm}`); setConfirm(null); toast.success("SİLİNDİ"); load(); };

  const open = tasks.filter((t) => !t.done);
  const done = tasks.filter((t) => t.done);
  const overdue = (t) => t.due_at && !t.done && new Date(t.due_at) < new Date();

  const Card = ({ t }) => (
    <div data-testid={`task-${t.id}`} className={`flex items-start gap-3 rounded-lg border p-3 ${t.done ? "border-slate-800 bg-slate-900/50 opacity-60" : overdue(t) ? "border-rose-700/50 bg-rose-950/20" : "border-slate-800 bg-slate-900"}`}>
      <Checkbox data-testid={`task-done-${t.id}`} checked={t.done} onCheckedChange={() => toggleDone(t)} className="mt-0.5" />
      <div className="min-w-0 flex-1">
        <div className={`font-semibold text-slate-100 ${t.done ? "line-through" : ""}`}>{t.title}</div>
        {t.note && <div className="text-sm text-slate-400">{t.note}</div>}
        <div className="mt-1 flex flex-wrap items-center gap-3 text-xs">
          {t.due_at && <span className={`flex items-center gap-1 ${overdue(t) ? "text-rose-400" : "text-blue-300"}`}><Clock className="h-3 w-3" />{new Date(t.due_at).toLocaleString("tr-TR")}{overdue(t) ? " (GEÇTİ)" : ""}</span>}
          {t.remind && t.due_at && <span className="flex items-center gap-1 text-amber-400"><Bell className="h-3 w-3" />{(LEAD.find((l) => l.v === t.remind_before) || {}).l || `${t.remind_before} DK ÖNCE`}</span>}
        </div>
      </div>
      <button data-testid={`task-del-${t.id}`} onClick={() => setConfirm(t.id)} className="rounded p-1 text-slate-500 hover:text-rose-400"><Trash2 className="h-4 w-4" /></button>
    </div>
  );

  return (
    <div className="mw-fade-up space-y-5" data-testid="tasks-page">
      <div>
        <h1 className="font-head text-3xl font-bold tracking-tight text-white flex items-center gap-2">
          <ListChecks className="h-7 w-7 text-indigo-400" /> İŞ LİSTESİ &amp; RANDEVULAR
        </h1>
        <p className="text-sm text-slate-400">KENDİ İŞLERİNİZİ VE RANDEVULARINIZI TAKİP EDİN. ZAMANI GELİNCE EKRANDA BALON HATIRLATMA GÖRÜNÜR.</p>
      </div>

      <div className="rounded-xl border border-slate-800 bg-slate-900 p-4">
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-12">
          <Input data-testid="task-title" placeholder="İŞ / RANDEVU BAŞLIĞI" value={form.title} onChange={(e) => setForm((f) => ({ ...f, title: trUpper(e.target.value) }))} className="h-10 border-slate-700 bg-slate-800 text-slate-100 sm:col-span-4" />
          <Input data-testid="task-note" placeholder="NOT (opsiyonel)" value={form.note} onChange={(e) => setForm((f) => ({ ...f, note: trUpper(e.target.value) }))} className="h-10 border-slate-700 bg-slate-800 text-slate-100 sm:col-span-3" />
          <Input data-testid="task-due" type="datetime-local" value={form.due_at} onChange={(e) => setForm((f) => ({ ...f, due_at: e.target.value }))} className="h-10 border-slate-700 bg-slate-800 text-slate-100 sm:col-span-3" />
          <select data-testid="task-lead" value={form.remind_before} onChange={(e) => setForm((f) => ({ ...f, remind_before: e.target.value }))} className="h-10 rounded-md border border-slate-700 bg-slate-800 px-2 text-sm text-slate-100 sm:col-span-2">
            {LEAD.map((l) => <option key={l.v} value={l.v}>{l.l}</option>)}
          </select>
        </div>
        <div className="mt-3 flex items-center justify-between gap-3">
          <label className="flex cursor-pointer items-center gap-2 text-sm text-slate-300">
            <Checkbox checked={form.remind} onCheckedChange={(v) => setForm((f) => ({ ...f, remind: v }))} /> <AlarmClock className="h-4 w-4 text-amber-400" /> HATIRLAT
          </label>
          <Input data-testid="task-phone" placeholder="SMS İÇİN TELEFON (+90…) opsiyonel" value={form.phone} onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))} className="h-9 max-w-xs border-slate-700 bg-slate-800 text-slate-100" />
          <Button data-testid="add-task" onClick={add} className="bg-indigo-600 text-white hover:bg-indigo-700"><Plus className="mr-1 h-4 w-4" /> İŞ EKLE</Button>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
        <div className="space-y-2">
          <h2 className="text-sm font-bold uppercase tracking-wider text-slate-400">AÇIK İŞLER ({open.length})</h2>
          {open.length === 0 && <div className="rounded-lg border border-slate-800 bg-slate-900 px-4 py-8 text-center text-sm text-slate-500">AÇIK İŞ YOK</div>}
          {open.map((t) => <Card key={t.id} t={t} />)}
        </div>
        <div className="space-y-2">
          <h2 className="flex items-center gap-1 text-sm font-bold uppercase tracking-wider text-slate-400"><CheckCircle2 className="h-4 w-4 text-emerald-400" /> TAMAMLANAN ({done.length})</h2>
          {done.length === 0 && <div className="rounded-lg border border-slate-800 bg-slate-900 px-4 py-8 text-center text-sm text-slate-500">TAMAMLANAN İŞ YOK</div>}
          {done.map((t) => <Card key={t.id} t={t} />)}
        </div>
      </div>

      <ConfirmDialog open={!!confirm} onOpenChange={(v) => !v && setConfirm(null)} title="İŞ SİLİNSİN Mİ?" onConfirm={del} />
    </div>
  );
}
